import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, isRef as _isRef, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7737fe31"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "flex-sb wrap",
  style: {"gap":"60px"}
}
const _hoisted_2 = { class: "flex-ct column left" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-ct t-font" }, [
  /*#__PURE__*/_createElementVNode("div", null, "移植问题，有问必答")
], -1))
const _hoisted_4 = { class: "flex-sb column base-box top" }
const _hoisted_5 = { class: "img" }
const _hoisted_6 = { class: "info" }
const _hoisted_7 = {
  key: 0,
  class: "status-section"
}
const _hoisted_8 = { class: "status-content" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "status-spinner",
  viewBox: "0 0 24 24",
  width: "16",
  height: "16"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    "stroke-width": "2",
    fill: "none",
    opacity: "0.25"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12 2 A10 10 0 0 1 22 12",
    stroke: "currentColor",
    "stroke-width": "2",
    fill: "none",
    "stroke-linecap": "round"
  })
], -1))
const _hoisted_10 = {
  key: 1,
  class: "think-section"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "think-icon" }
const _hoisted_13 = {
  key: 0,
  class: "thinking-spinner",
  viewBox: "0 0 24 24",
  width: "16",
  height: "16"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "2",
  fill: "none",
  opacity: "0.25"
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M12 2 A10 10 0 0 1 22 12",
  stroke: "currentColor",
  "stroke-width": "2",
  fill: "none",
  "stroke-linecap": "round"
}, null, -1))
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = {
  key: 1,
  viewBox: "0 0 24 24",
  width: "16",
  height: "16",
  fill: "currentColor"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" }, null, -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "think-title" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M7 10l5 5 5-5z" }, null, -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 0,
  class: "think-content"
}
const _hoisted_24 = {
  key: 0,
  class: "think-empty"
}
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = {
  key: 0,
  class: "think-cursor"
}
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip" }, " AI生成仅供参考，如需诊断或者药物使用指导，请咨询医生或者到科室就诊。 ", -1))
const _hoisted_32 = { class: "base-box d-foot" }
const _hoisted_33 = {
  class: "flex-sb",
  style: {"align-items":"center"}
}
const _hoisted_34 = { class: "model-selector" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M7 10l5 5 5-5z" }, null, -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = { class: "model-list" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "model-title" }, "模型选择", -1))
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "model-name" }
const _hoisted_41 = { class: "model-desc" }
const _hoisted_42 = {
  class: "flex",
  style: {"gap":"12px"}
}
const _hoisted_43 = { class: "flex-ct column right" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "t-font" }, "看看大家都在问什么", -1))
const _hoisted_45 = {
  class: "base-box",
  style: {"flex":"1","overflow-y":"auto"}
}
const _hoisted_46 = { class: "block" }
const _hoisted_47 = { class: "img" }
const _hoisted_48 = ["innerHTML"]

import { Image, Button, Popover } from "vant";
import { Ref, ref, unref, reactive, nextTick, onMounted } from "vue";
import { QAList } from "./config";
import axios from "axios";
// import API from "@/api/index";
import MarkdownIt from "markdown-it";
type Evaluate = "like" | "badreview" | false | true;
interface MsgList {
  img: string;
  cnt: string;
  thinkContent?: string; // 思考过程内容
  mainContent?: string; // 正文内容
  isThinking?: boolean; // 是否正在思考
  showThink?: boolean; // 是否展开思考过程
  statusText?: string; // 任务分配状态文本
  user: boolean; //判断是否是使用者还是AI的回答
  evaluate: Evaluate; //判断该条评论是否展示评价按钮或者其评价状态
  gather: boolean; //判断该条评论是否展示数据采集单
}

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const markdown = new MarkdownIt();

let histroyList = reactive<Array<Array<MsgList>>>([]);
let msgList = reactive<Array<MsgList>>([
  {
    img: "../../assets/icon/PropertyAI.png",
    cnt: "您好，我叫易知，是中山医院肾脏移植科室的智能助手。我可以解答您肾移植相关问题，不过我还在学习中，会慢慢的增长知识。请问您有什么问题呢？",
    mainContent: "您好，我叫易知，是中山医院肾脏移植科室的智能助手。我可以解答您肾移植相关问题，不过我还在学习中，会慢慢的增长知识。请问您有什么问题呢？",
    thinkContent: "",
    statusText: "",
    isThinking: false,
    showThink: false,
    user: false,
    evaluate: false,
    gather: false,
  },
]);

const popoverRef = ref();

const model = ref("Eknow"); // 添加模型状态变量

const showPopover = ref(false); // 添加控制 popover 显示状态的变量

// 定义可选的模型列表
// 统一使用相对路径，通过服务器反向代理访问真实接口
const modelOptions = [
  {
    name: "Eknow",
    description: "中山医院肾脏移植科室智能助手，解答肾移植相关问题。",
    apiUrl: "/eknow-api/",
  },
  {
    name: "DeepSeek V3",
    description: "多功能大型语言模型，适合各种语言处理任务。",
    apiUrl: "/deepseek-api/"
  },
];

//切换模型
function changeModel(newModel: string) {
  model.value = newModel;
  showPopover.value = false; // 关闭弹窗
}

/** 消息发送 */
let msg: Ref<string> = ref("");
// 修改历史记录结构，支持两种模型的不同格式
let historyArr: Array<{role: string, content: string}> = [];
const sending = ref(false);
let currentQuestion = ""; // 保存当前问题
const sendMsg = () => {
  sending.value = true;
  currentQuestion = msg.value; // 保存当前问题
  msgList.push({
    img: "",
    cnt: msg.value,
    mainContent: msg.value,
    thinkContent: "",
    statusText: "",
    isThinking: false,
    showThink: false,
    user: true,
    evaluate: false,
    gather: false,
  });
  autoScroll();

  //api
  let data;
  if (model.value === "DeepSeek V3") {
    // DeepSeek V3 使用 [{role, content}] 格式
    data = {
      history: historyArr,
      question: msg.value,
    };
    console.log('DeepSeek V3 请求数据:', JSON.stringify(data, null, 2));
  } else {
    // Eknow 使用 [{role, content}] 格式
    data = {
      question: msg.value,
      history: historyArr,
      model: "EKnow-32B",
      current_user: {
        id: "1",
        name: "测试用户",
        relationship: "自己",
        gender: "男"
      },
      managed_users: []
    };
  }
  getStreamWithParams(
    data,
    modelOptions.find((option) => option.name === model.value)?.apiUrl || ""
  );
  msg.value = "";
};

async function getStreamWithParams(params: any, url: RequestInfo | URL) {
  try {
    const requestOptions = {
      method: "POST",
      headers: {
        Accept: "text/event-stream", // 告诉服务器我们期望接收服务器发送事件（SSE）
        "Cache-Control": "no-cache", // 确保不缓存响应
        "Content-Type": "application/json",
      },
      body: JSON.stringify(params), // 如果是 POST 或 PUT 请求，将参数序列化为 JSON 字符串
    };

    // 添加日志
    console.log("Sending request to:", url);
    console.log("Request params:", params);

    // 对于Eknow模型，显示"正在任务分配中"
    const isEknow = model.value === "Eknow";
    
    msgList.push({
      img: "",
      cnt: "",
      thinkContent: "",
      mainContent: "",
      statusText: isEknow ? "Eknow正在任务分配中" : "",
      isThinking: false,
      showThink: false,
      user: false,
      evaluate: false,
      gather: false,
    });

    let response = await fetch(url, requestOptions);
    if (!response.ok) {
      console.error("Response error:", response.status, response.statusText);
      throw new Error("Network response was not ok");
    }

    const reader = response!.body!.getReader();
    const textDecoder = new TextDecoder();
    let result = true;
    let inThinkTag = false; // 是否在 <think> 标签内
    let thinkBuffer = ""; // 思考内容缓冲区
    let intentReceived = false; // 是否已接收intent

    while (result) {
      const { done, value } = await reader.read();
      if (done) {
        console.log("Stream ended");
        // 保存历史记录
        const lastMsg = msgList.at(-1);
        if (lastMsg) {
          lastMsg.isThinking = false;
          lastMsg.statusText = ""; // 清除状态文本
          // 根据思考内容是否为空决定是否展开
          // 有内容则展开，没内容则收起
          if (lastMsg.thinkContent && lastMsg.thinkContent.trim() !== '') {
            lastMsg.showThink = true;
          } else {
            lastMsg.showThink = false;
          }
        }
        const aiResponse = msgList.at(-1)?.mainContent || msgList.at(-1)?.cnt || "";
        if (currentQuestion && aiResponse) {
          // 保存为新的历史记录格式
          historyArr.push({ role: "user", content: currentQuestion });
          historyArr.push({ role: "assistant", content: aiResponse });
        }
        sending.value = false;
        result = false;
        break;
      }
      const chunkText = textDecoder.decode(value, { stream: true });

      // 处理流式响应数据
      chunkText.split("data: ").forEach((item, index) => {
        if (index != 0 && item.trim()) {
          // 跳过 [DONE] 标记
          if (item.trim() === "[DONE]") {
            return;
          }
          
          try {
            const jsonData = JSON.parse(item);
            
            // 处理Eknow的intent响应
            if (isEknow && !intentReceived && jsonData.intent) {
              intentReceived = true;
              const lastMsg = msgList.at(-1)!;
              const { is_healthrecord, is_internet } = jsonData.intent;
              
              // 根据intent设置状态文本
              if (is_healthrecord === 1 && is_internet === 1) {
                lastMsg.statusText = "正在联网检索中";
              } else if (is_healthrecord === 1) {
                lastMsg.statusText = "调取健康档案中";
              } else if (is_internet === 1) {
                lastMsg.statusText = "联网检索中";
              } else {
                lastMsg.statusText = "";
              }
              
              autoScroll();
              return;
            }
            
            let content = "";
            const lastMsg = msgList.at(-1)!;
            
            // 处理Eknow的content格式
            if (jsonData.content !== undefined) {
              content = jsonData.content;
              // 开始接收消息流时，立即清除状态文本（即使content为空）
              if (lastMsg.statusText) {
                console.log('清除状态文本:', lastMsg.statusText, '开始渲染内容');
                lastMsg.statusText = "";
                autoScroll();
              }
            }
            // 处理choices格式（DeepSeek V3）
            else if (jsonData.choices && jsonData.choices.length > 0) {
              jsonData.choices.forEach((val: any) => {
                if (val.delta && val.delta.content) {
                  content += val.delta.content;
                }
              });
              // 开始接收消息流时，立即清除状态文本
              if (lastMsg.statusText) {
                lastMsg.statusText = "";
              }
            }
            
            // 只处理非空内容
            if (content) {
              lastMsg.cnt += content;
              console.log('接收内容片段:', content);
              
              // 解析 <think> 标签
              let tempContent = lastMsg.cnt;
              
              // 检查是否包含 <think> 标签
              const hasThinkTag = /<think>/i.test(tempContent);
              
              if (hasThinkTag) {
                // 尝试匹配完整的 <think>...</think> 标签
                const thinkCompleteMatch = tempContent.match(/<think>([\s\S]*?)<\/think>/i);
                
                if (thinkCompleteMatch) {
                  // 思考标签已完整闭合
                  lastMsg.thinkContent = thinkCompleteMatch[1]; // 只保存标签内的内容，不包含标签本身
                  lastMsg.isThinking = false;
                  // 根据思考内容是否为空决定是否展开
                  lastMsg.showThink = !!(lastMsg.thinkContent && lastMsg.thinkContent.trim() !== '');
                  // 提取正文内容（去除整个 <think>...</think> 标签）
                  lastMsg.mainContent = tempContent.replace(/<think>[\s\S]*?<\/think>/i, "").trim();
                } else {
                  // 标签未闭合，仍在思考中
                  const thinkPartialMatch = tempContent.match(/<think>([\s\S]*?)$/i);
                  if (thinkPartialMatch) {
                    lastMsg.thinkContent = thinkPartialMatch[1]; // 只保存标签内的内容
                    lastMsg.isThinking = true;
                    // 思考时，如果有内容就展开，没内容就收起
                    lastMsg.showThink = !!(lastMsg.thinkContent && lastMsg.thinkContent.trim() !== '');
                    lastMsg.mainContent = ""; // 思考中时正文为空
                  }
                }
              } else {
                // 没有 <think> 标签
                if (lastMsg.thinkContent) {
                  // 之前有思考内容，现在继续是正文（确保去除标签）
                  lastMsg.mainContent = tempContent.replace(/<think>[\s\S]*?<\/think>/i, "").trim();
                } else {
                  // 普通内容，没有思考过程
                  lastMsg.mainContent = tempContent;
                }
              }
              
              autoScroll();
            }
          } catch (e) {
            console.error("Failed to parse chunk:", item, e);
          }
        }
      });
    }
  } catch (e) {
    console.error(e);
  }
}

/**评价处理 */
const evaluate: Ref<Evaluate> = ref(false);
const changeEvaluate = (e: Evaluate) => {
  const l = msgList.length - 1;
  for (let i = l; i > 0; i--) {
    if (msgList[i].evaluate) {
      msgList[i].evaluate = e;
      break;
    }
  }
  const data = {
    value: e,
  };
  //api
  axios.post("/api/postEvaluate", data).then((response) => {
    msgList.push(response.data);
    evaluate.value = e;
  });
};

/** 自动定位到底部  */
const scrollContainer = ref(null) as any;
const autoScroll = () => {
  nextTick(() => {
    if (scrollContainer.value) {
      scrollContainer.value.scrollTop = scrollContainer.value.scrollHeight;
    }
  });
};

onMounted(() => {
  // 组件挂载后滚动到底部
  autoScroll();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "info-box",
          ref_key: "scrollContainer",
          ref: scrollContainer
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(msgList), (item, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createElementVNode("div", {
                class: "block",
                style: _normalizeStyle(item.user ? 'flex-direction: row-reverse' : '')
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_unref(Image), {
                    round: "",
                    width: "32px",
                    height: "32px",
                    src: 
                    item.user
                      ? require('../../assets/icon/PropertyUser.png')
                      : require('../../assets/icon/customer.png')
                  
                  }, null, 8, ["src"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  (!item.user && item.statusText)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _hoisted_9,
                          _createElementVNode("span", null, _toDisplayString(item.statusText), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!item.user && (item.isThinking || item.thinkContent))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("div", {
                          class: "think-header think-header-clickable",
                          onClick: ($event: any) => (item.showThink = !item.showThink)
                        }, [
                          _createElementVNode("div", _hoisted_12, [
                            (item.isThinking)
                              ? (_openBlock(), _createElementBlock("svg", _hoisted_13, _hoisted_16))
                              : (_openBlock(), _createElementBlock("svg", _hoisted_17, _hoisted_19))
                          ]),
                          _createElementVNode("span", _hoisted_20, _toDisplayString(item.isThinking ? '深度思考中...' : '思考过程'), 1),
                          (item.isThinking || item.thinkContent)
                            ? (_openBlock(), _createElementBlock("svg", {
                                key: 0,
                                class: _normalizeClass(["think-arrow", { 'think-arrow-expand': item.showThink }]),
                                viewBox: "0 0 24 24",
                                width: "16",
                                height: "16",
                                fill: "currentColor"
                              }, _hoisted_22, 2))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_11),
                        (item.showThink)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                              (!item.thinkContent || item.thinkContent.trim() === '')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                    (item.isThinking)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_25, "思考中..."))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_26, "暂无思考内容"))
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                    _createElementVNode("div", {
                                      innerHTML: _unref(markdown).render(item.thinkContent)
                                    }, null, 8, _hoisted_28),
                                    (item.isThinking)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_29, "▋"))
                                      : _createCommentVNode("", true)
                                  ]))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (item.user || item.mainContent || (!item.thinkContent && item.cnt))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: "cnt",
                        style: _normalizeStyle(item.user ? 'color: #4556A4' : ''),
                        innerHTML: _unref(markdown).render(item.user ? item.cnt : (item.mainContent || item.cnt))
                      }, null, 12, _hoisted_30))
                    : _createCommentVNode("", true)
                ])
              ], 4)
            ]))
          }), 128))
        ], 512),
        _hoisted_31
      ]),
      _createElementVNode("div", _hoisted_32, [
        _withDirectives(_createElementVNode("textarea", {
          name: "",
          id: "",
          class: "d-input",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(msg) ? (msg).value = $event : msg = $event)),
          placeholder: "请输入您的问题...",
          onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (sendMsg()), ["enter"]))
        }, null, 544), [
          [_vModelText, _unref(msg)]
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createVNode(_unref(Popover), {
            placement: "top-start",
            width: 280,
            show: showPopover.value,
            "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((showPopover).value = $event)),
            trigger: "click"
          }, {
            reference: _withCtx(() => [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("span", null, _toDisplayString(model.value), 1),
                (_openBlock(), _createElementBlock("svg", {
                  viewBox: "0 0 24 24",
                  width: "14",
                  height: "14",
                  fill: "currentColor",
                  style: _normalizeStyle(showPopover.value ? 'transform: rotate(180deg)' : '')
                }, _hoisted_36, 4))
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(modelOptions, (option) => {
                  return _createElementVNode("div", {
                    key: option.name,
                    class: _normalizeClass(["model-item", { 'model-item-active': option.name === model.value }]),
                    onClick: ($event: any) => (changeModel(option.name))
                  }, [
                    _createElementVNode("div", _hoisted_40, _toDisplayString(option.name), 1),
                    _createElementVNode("div", _hoisted_41, _toDisplayString(option.description), 1)
                  ], 10, _hoisted_39)
                }), 64))
              ])
            ]),
            _: 1
          }, 8, ["show"]),
          _createElementVNode("div", _hoisted_42, [
            _createVNode(_unref(Button), {
              style: {"width":"55px"},
              size: "small",
              type: "primary",
              disabled: _unref(msg) && !sending.value ? false : true,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (sendMsg()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(sending.value ? "发送中" : "发送"), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_43, [
      _hoisted_44,
      _createElementVNode("div", _hoisted_45, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(QAList), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            style: {"margin":"10px"}
          }, [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createVNode(_unref(Image), {
                  round: "",
                  width: "32px",
                  height: "32px",
                  src: 
                  item.user
                    ? require('../../assets/icon/answer.png')
                    : require('../../assets/icon/question.png')
                
                }, null, 8, ["src"])
              ]),
              _createElementVNode("div", {
                class: "info",
                style: _normalizeStyle(item.user ? 'background: #EBF4FF;' : '')
              }, [
                _createElementVNode("div", {
                  class: "cnt",
                  innerHTML: _unref(markdown).render(item.cnt)
                }, null, 8, _hoisted_48)
              ], 4)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})